import Api from "./api";

export default class GraphqlApi extends Api {
	constructor(token, clientId, onUnauthorized) {
		super(token, clientId, onUnauthorized);
		this.baseUrl = this.getBaseUrl() + "gql/";
	}

	async query(query, variables, onSuccess, onError) {
		let response;
		try {
			response = await fetch(this.baseUrl, {
				method: "POST",
				body: JSON.stringify({ query, variables }),
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					Authorization: this.getToken(),
				},
			});
		} catch (err) {
			onError(["Couldn't connect to server."]);
			return;
		}

		if (response.status === 401) {
			this.onUnauthorized();
			return;
		}

		const body = await response.json().catch(() => ({}));
		if (body.errors?.length) {
			onError(body.errors.map((e) => e.message));
		} else if (!response.ok) {
			onError(["Unexpected problem when fetching data."]);
		} else {
			onSuccess(body.data);
		}
	}
}
